import dayjs, { Dayjs } from 'dayjs';

export const convertDate = (date: Date | null | Dayjs, separator = '-'): string | null => {
	const format = `YYYY${separator}MM${separator}DD`;
	if (date) {
		return dayjs(date).format(format);
	}
	return date;
};
